import { Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useState, lazy, Suspense } from "react";
import { format, parseISO } from "date-fns";
import axios from "axios";
import "@fontsource/poppins";
import "./App.css";
import { PressReleaseComponent } from "press-release";
import BannerCarousel from './components/BannerCarousel';
import { Outlet } from "react-router-dom";
import { useParams } from 'react-router-dom';

const Header = lazy(() => import("./components/Header"));
const Highlights = lazy(() => import("./components/Highlights"));

const LoanCalculator = lazy(() => import("./components/LoanCalculator"));
// const News = lazy(()=>import("./components/InTheNews/js/News"));
const VideoCarousel = lazy(() => import("./components/VideoCarousel/index.js"));
const LogoSection = lazy(() => import("./components/Logo Section/Logo"));
const Navbar = lazy(() => import("./components/Navbar"));


function Home() {
  const imgCDNURL = process.env.REACT_APP_MORTGAGES4VETERANS_CDN_URL;
  const params = useParams()

  const [Myuser, setMyuser] = useState("");
  const [showMortgage, setShowMortgage] = useState(false);

  // const [themeId, setThemeId] = useState("jonathanlinhart-pricing");
  const [configJSON, setConfigJSON] = useState("");
  const [va15, setVA15] = useState("");
  const [va30, setVA30] = useState("");
  const [pricingAsOfDate, setPricingAsOfDate] = useState("");

  async function locationError(error) {
    // Get the default price scenario
    await getPrice();
  }

  /**
   * @description Get the pricing config file details
   * 
   */
  const getConfigData = async (user) => {
    try {
      // Get the mortgage4veterans-config.json file from S3 bucket
      const configData = await axios(
        `${process.env.REACT_APP_RATE_PRODUCT}/${user.pricingjson}`
      );
      getPrice(null, user);
      //console.log(JSON.stringify(configData.data[0]));
      if (configData.data[1].VA_30_YR_FIXED) {
        setConfigJSON(configData.data[1].VA_30_YR_FIXED);
      }
    } catch (error) {
      console.error("Unable to load jonathanlinhart-config.json file from S3 bucket: ", error);
    }
  };

  /**
   * @description Get the static pricing data from s3.
   * 
   */
  const getPrice = async (userStateCode, user) => {
    try {
      // Get the static data from s3 for the filtered state else return the default data
      // Get the state list
      const stateList = await axios(
        `${process.env.REACT_APP_RATE_PRODUCT}/state.json`
      );
      // Filter the state which has the county and zipcode
      const propertyStateData = stateList.data.find(
        (d) => d.state.code === userStateCode
      );

      //console.log("propertyStateData: " + JSON.stringify(propertyStateData));
      let response;
      if (propertyStateData) {
        const county = propertyStateData.state.county.code;
        const zipcode = propertyStateData.state.county.zipcode;
        // console.log("county: " + county);
        // console.log("zipcode: " + zipcode);
        // console.log("themeId: " + themeId);
        response = await axios(
          `${process.env.REACT_APP_RATE_PRODUCT
          }/${Myuser.Lambda}/${userStateCode.toLowerCase()}/${county}/${zipcode}/products.json`
        ).catch((error) => {
          console.error("Unable to pull pricing for user state: ", error);
          locationError();
        });
      } else {
        response = await axios(
          `${process.env.REACT_APP_RATE_PRODUCT}/${user.Lambda ? user.Lambda : Myuser.Lambda}/default.json`
        );
      }

      const parseValue = parseISO(response.data.createdAt);
      const dateTime = format(parseValue, "MM/dd/yyyy hh:mm a");
      setPricingAsOfDate(dateTime);

      if (response.data.VA_15_YR_FIXED) {
        setVA15(response.data.VA_15_YR_FIXED);
      }

      if (response.data.VA_30_YR_FIXED) {
        setVA30(response.data.VA_30_YR_FIXED);
      }
    } catch (error) {
      console.error("Unable to load todays rate: ", error);
    }
  };

  useEffect(() => {
    let userIP = "";
    let userZipcode = "";
    let userState = "";

    const fetchData = async (user) => {
      await axios
        .get("https://api.ipify.org", { timeout: 5000 })
        .then((response) => {
          userIP = response.data;
          getConfigData(user);

          //console.log("userIP: " + userIP);
          if (userIP) {
            axios
              .post(
                process.env.REACT_APP_MAXMIND,
                { ip: userIP },
                {
                  headers: { "Content-Type": "application/json" },
                },
                { timeout: 5000 }
              )
              .then((response) => {
                //console.log("response.data: " + JSON.stringify(response.data));
                if (
                  response.data !== "IP Not Available" &&
                  response.data !== "Invalid Country"
                ) {
                  userZipcode = response.data.zipcode;
                  //console.log("userZipcode: " + userZipcode);
                  if (userZipcode) {
                    axios
                      .get(
                        process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + userZipcode,
                        {
                          headers: { "Content-Type": "application/json" },
                        },
                        { timeout: 5000 }
                      )
                      .then((response) => {
                        userState = response.data.state;
                        console.log("userState: " + userState);
                        // get the price scenario
                        getPrice(userState, Myuser);
                      })
                      .catch((error) => {
                        console.error("Get ZIPCODE Error: ", error);
                        locationError();
                      });
                  } else {
                    locationError();
                  }
                } else {
                  locationError();
                }
              })
              .catch((error) => {
                console.error("Post MAXMIND Error: ", error);
                locationError(error);
              });
          }
        })
        .catch((error) => {
          console.error("Get ipify Error: ", error);
          locationError(error);
        });
    };
    if (params.LOid === "guides") {
      setShowMortgage(true)
    } else {
      setShowMortgage(false)
      axios.get(process.env.REACT_APP_LODETAILS_CDN_URL).then((response) => {
        // setMyUser(response);
        if (response && response.status === 200) {
          const data = response.data
          // const data = users
          for (let i = 0; i < data.length; i++) {
            if (data[i].url === params.LOid) {
              setMyuser(data[i])
              fetchData(data[i]);
              break
            }
          }
        }
      });

    }

  }, []);

  return (
    <>
      <div className="bodyContainer mb-5">
        <img
          src={imgCDNURL + "6dots-group.png"}
          className="dots-group img-fluid"
          alt="6dots-group"
        />
        <img
          src={imgCDNURL + "va-desktop.webp"}
          className="desktop-bg img-fluid"
          alt="desktop-bg"
        />
        <img
          src={imgCDNURL + "va-mobile.webp"}
          className="mobile-bg img-fluid"
          alt="mobile-bg"
        />
        <Suspense fallback={<div />}>
          <Navbar />
        </Suspense>
        <Suspense fallback={<div />}>
          <Header configJSON={configJSON} va15={va15} va30={va30} pricingAsOfDate={pricingAsOfDate} />
        </Suspense>
      </div>
      <Suspense fallback={<div />}>
        <LogoSection />
      </Suspense>
      <Suspense fallback={<div />}>
        <Highlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <div className="news pt-4">
          <PressReleaseComponent />
        </div>
      </Suspense>
      <Suspense fallback={<div />}>
        <BannerCarousel title="Video Testimonials" />
      </Suspense>
      <Suspense fallback={<div />}>
        {va30 ? <LoanCalculator offerRate={va30.rate} offerTerm={360} /> : ""}
      </Suspense>
      <Outlet />
    </>
  );
}

export default Home;